type StatBarProps = {
  label: string;
  value: number;
  total: number;
  tone?: 'primary' | 'destructive';
};

// Dependency-free bar chart primitive (no charting library in this project
// yet) - a labeled row with a proportional-width fill, used across the
// Funnel/Permissions/Protect Mode analytics pages.
const StatBar = (props: StatBarProps) => {
  const { label, value, total, tone = 'primary' } = props;
  const percent = total > 0 ? Math.round((value / total) * 100) : 0;
  const barColor = tone === 'destructive' ? 'bg-destructive' : 'bg-primary-green-600';

  return (
    <div className='flex flex-col gap-1'>
      <div className='flex items-center justify-between text-sm'>
        <span className='text-foreground'>{label}</span>
        <span className='text-muted-foreground'>
          {value.toLocaleString()} ({percent}%)
        </span>
      </div>
      <div className='h-2 w-full overflow-hidden rounded-full bg-muted'>
        <div className={`h-full rounded-full ${barColor}`} style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
};

export default StatBar;
